import { useTheme } from 'styled-components';

type Variant = 'text' | 'circular' | 'rectangular' | 'rounded';

interface Props {
  className?: string;
  height?: string | number;
  width?: string | number;
  variant?: Variant;
}

const radius: Record<Variant, string> = {
  circular: '50%',
  rectangular: '0px',
  rounded: '8px',
  text: '8px',
};

export const Skeleton = (props: Props) => {
  const { width = '100%', height = 20, variant = 'text' } = props;
  const theme = useTheme();

  return (
    <div
      className={props.className}
      style={{
        backgroundColor: theme.palette.common.PLACEHOLDER,
        borderRadius: radius[variant],
        height,
        width,
      }}
    />
  );
};
